import { cloneDeep } from 'lodash';
import { useContext, useEffect, useState } from 'react';
import List from '../../../../commonComponents/List/List';
import { ProjectsContext } from '../../Projects';
import { projectsListColumns } from './ProjectsList.columns';
import FilterInput from '../../../../commonComponents/FilterInput/FilterInput';
import { FilterWrapper } from './ProjectsList.styles';
import { useNavigate } from 'react-router';
import { PrimaryButton } from '@fluentui/react';
import { useTranslation } from 'react-i18next';
import ModalCreator from '../../../modals/modalCreator';
import { LocationsModal } from '../LocationsModal/LocationsModal';
import StackHorizontal from '../../../StackHorizontal/StackHorizontal';

/**
 * Компонент для отрисовки списка всех проектов
 */
const ProjectsList = () => {
    const { storeSelectedProjectIdTrans, projects } = useContext(ProjectsContext);
    const [filteredProjects, setFilteredProjects] = useState([]);
    const [locationsModalState, setLocationsModalState] = useState({ show: false });
    const nav = useNavigate();
    const { t } = useTranslation();

    useEffect(() => {
        projects.length && setFilteredProjects(cloneDeep(projects));
    }, [projects]);

    const onRowClick = (row) => {
        storeSelectedProjectIdTrans(row.id);
        nav(`/projects/${row.id}`);
    };

    const onShowAllLocationsClick = () => {
        setLocationsModalState({ show: true });
    };

    const onCloseAllLocationsClick = () => {
        setLocationsModalState({ show: false });
    };

    return (
        <>
            <ModalCreator isModalOpen={locationsModalState.show} closeModal={onCloseAllLocationsClick}>
                <LocationsModal closeModal={onCloseAllLocationsClick} />
            </ModalCreator>
            <StackHorizontal>
                <FilterWrapper>
                    <FilterInput
                        inputArray={projects}
                        updateFilteredArray={setFilteredProjects}
                        matchFields={['name', 'id', 'date_from', 'date_to']}
                    />
                </FilterWrapper>
                <PrimaryButton text={t('View all locations')} onClick={onShowAllLocationsClick} allowDisabledFocus />
            </StackHorizontal>

            <List
                onRowClick={onRowClick}
                items={filteredProjects}
                columns={projectsListColumns}
                availableSortKeys={['name', 'id', 'date_from', 'date_to']}
            />
        </>
    );
};
export default ProjectsList;
